import GatewayContainer from "./gateway_container";
import { Gateway } from "../types/payment_gateway";
import { gatewayMetaMap } from "../utils/gatewayMetaMap";

export default function GatewaysBody({ gateways }: { gateways: Gateway[] }) {
  return (
    <div className="w-full flex items-center justify-start gap-x-6">
      {gateways.map((gateway) => {
        const meta = gatewayMetaMap[gateway.name] || {
          currency: "USD",
          bgColor: "#F3CBCB",
          imgSrc: "/images/gateways/default.png",
        };

        return (
          <GatewayContainer
            key={gateway.name}
            name={gateway.name}
            country={gateway.region}
            lifetime="Lifetime"
            currency={meta.currency}
            status="Active"
            bgColor={meta.bgColor}
            logo={<img src={meta.imgSrc} alt={gateway.name} className="h-12" />}
          />
        );
      })}
    </div>
  );
}
